// @flow
import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';

import { useCopy } from 'hooks/useCopy';
import { UserContext } from 'shared/userContext/UserContext';
import { Heading, Paragraph, Button } from 'operation-diameter';

import styles from './ErrorPage.module.css';

export const ErrorPage = () => {
  const location = useLocation();
  const { type } = useContext(UserContext);
  const { getCopy } = useCopy();
  const { message } = location.state || {};
  const loanAppErrorUrl = location.pathname.includes('loan-application');

  const handleRetry = () => {
    type === 'broker'
      ? window.location.assign('/uk/broker/loan-application/processing')
      : window.location.assign('/uk/borrower/loan-application/processing');
  };

  return (
    <div className={styles.errorWrapper} data-testid='legacy-error'>
      <Heading headingSize='h6'>{getCopy('shared.errorPage.title')}</Heading>
      {loanAppErrorUrl ? (
        <div className={styles.errorMessage}>
          <Paragraph>
            {getCopy('shared.errorPage.loanAppError.paragraph')}
          </Paragraph>

          <Paragraph>
            {getCopy('shared.errorPage.loanAppError.secondParagraph')}
          </Paragraph>

          <Button
            size='large'
            additionalClassnames={styles.buttonContent}
            type='button'
            onClick={handleRetry}>
            {getCopy('shared.errorPage.loanAppError.button')}
          </Button>
        </div>
      ) : (
        <Paragraph>
          {getCopy('shared.errorPage.nonLoanAppError.paragraph')}
        </Paragraph>
      )}
      <Paragraph>{message}</Paragraph>
    </div>
  );
};
